export const CHECKIN_FEED_NAVIGATION_BUTTON_TEST_ID = 'checkin-feed-navigation-button'
export const CHECKIN_FEED_GO_TO_LATEST_BUTTON_TEST_ID = 'checkin-feed-go-to-latest-button'

export const CHECKIN_FEED_TOOLBAR_FILTERS_LIST_TEST_ID = 'checkin-feed-toolbar-filters-list'
export const CHECKIN_FEED_TOOLBAR_FILTER_BUTTON_TEST_ID = 'checkin-feed-toolbar-filter-button'
export const CHECKIN_FEED_TOOLBAR_ADD_FILTER_BUTTON_TEST_ID =
  'checkin-feed-toolbar-add-filter-button'

export const CHECKIN_FEED_TOOLBAR_FILTER_BUTTON_TEST_ID_ELEMENT =
  'checkin-feed-toolbar-filter-button-element'

export const CHECKIN_FEED_TOOLBAR_FILTER_EDIT_BUTTON_TEST_ID =
  'checkin-feed-toolbar-filter-edit-button'

export const CHECKIN_FILTER_MODAL_DELETE_BUTTON_TEST_ID = 'delete-button'
export const CHECKIN_FILTER_MODAL_NAME_INPUT_TEST_ID = 'filter-name-input'
export const CHECKIN_FILTER_MODAL_NAME_ERROR_TEST_ID = 'filter-name-error'
export const CHECKIN_FILTER_OWNERS_SELECT_TEST_ID = 'filter-owners-select'
export const CHECKIN_FILTER_GROUPS_SELECT_TEST_ID = 'filter-groups-select'
